<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px;">
        <div class="p-3">
            <Gallery :images="imagesForHeader" :keep-aspect-ratio="true" passClasses="max-h-[500px]" />
        </div>
        <div class="flex flex-col lg:flex-row py-12 md:py-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full lg:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">St. Mauritius und Andreas</h1>
                    <p class="text-lg text-gray-500 mt-3">Kleinneuhausen</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        Die denkmalgeschützte evangelisch-lutherische Kirche St. Mauritius und Andreas prägt das
                        Ortsbild von Kleinneuhausen im thüringischen Landkreis Sömmerda. Die große Saalkirche wurde von
                        1736 bis 1739 gebaut und integriert Teile eines mittelalterlichen Turms, dessen Wetterfahne bis
                        auf das Jahr 1739 datiert. Markant sind der Turm mit seiner Haube und Glocke von 1522, sowie die
                        klassisch barocke Architektur mit korbbogigen Fenstern und Werksteingliederung. Im Inneren
                        beeindrucken zweigeschossige Emporen, ein barocker Kanzelaltar von 1744 und eine um 1820 gebaute
                        Orgel mit 24 Registern. Als lebendiger Ort christlicher Gemeinschaft gehört die Kirche zum
                        Pfarrbereich Großbrembach im Kirchenkreis Apolda-Buttstädt der Evangelischen Kirche in
                        Mitteldeutschland.
                    </p>
                    <a href="https://de.wikipedia.org/wiki/St._Mauritius_und_Andreas_(Kleinneuhausen)"
                        class="text-sm text-gray-500 mt-5 hover:text-primary-default hover:underline flex w-48 gap-2 items-center">
                        <svg class="w-5 h-5 mb-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 12H5m14 0-4 4m4-4-4-4" />
                        </svg>
                        Mehr auf Wikipedia
                    </a>
                </div>
            </div>
            <div class="text-left sticky mt-16 lg:mt-0 flex-auto px-3 lg:px-0 pr-3 lg:pr-12 lg:pr-24 top-[115px] h-min">
                <div class="flex-auto lg:w-auto flex flex-col items-center">
                    <div class="flex flex-col w-full gap-3">
                        <div v-if="data.length > 0">
                            <p class="text-md text-gray-500 px-1 mt-3 mb-3">Nächster Gottesdienst</p>
                            <div class="flex flex-col gap-3">
                                <template v-for="(i, n) in data.slice(0, 2)" :key="n">
                                    <div class="bg-white rounded-md flex flex-col gap-3 text-left overflow-hidden select-none"
                                        style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                                        <div class="flex items-center justify-between px-3 py-2 bg-gray-500">
                                            <p class="text-sm text-white">{{ i.date }}</p>
                                            <p class="text-sm text-white">{{ i.time }}</p>
                                        </div>
                                        <div class="flex gap-10 p-3">
                                            <div>
                                                <p class="font-bold">{{ i.title }}</p>
                                                <p class="text-sm text-gray-500">Thema des Gottesdienstes</p>
                                            </div>
                                            <div class="ml-auto text-right" :title="i.location">
                                                <p>{{ i?.location.split(',').reverse()[0].replace(/\d+/g, "") }}</p>
                                                <p class="text-sm text-gray-500">Ort</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <p class="mt-4 italic text-right text-xs text-gray-500">Daten von <a
                                    href="https://kg-rastenberg.ekmd-online.de/gottesdienste/"
                                    class="hover:underline hover:text-primary-default font-bold">kg-rastenberg.ekmd-online.de</a>
                                bereitgestellt.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Gallery from '@/components/gallery.vue';

export default {
    name: "Olbersleben",
    data() {
        return {
            data: [],
            imagesForHeader: [
                {
                    url: "/assets/kirchen/kleinneuhausen/kleinneuhausen-1.webp",
                    alt: "Kleinneuhausen 1"
                },
                {
                    url: "/assets/kirchen/kleinneuhausen/kleinneuhausen-2.webp",
                    alt: "Kleinneuhausen 2"
                },
            ]
        }
    },
    components: {
        Gallery
    },
    async created() {
        this.data = (await this.$userStore.getData()).filter(f => f.location.includes("Kleinneuhausen"));
    }
}
</script>